/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import Tick from "./Tick";

// todo: suggest based on utilization

export default class DiagCodeSelectW extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            diagCodes: [],
            selected: []
        }
    }

    async componentDidMount() {
        if(Array.isArray(this.props.currentValues))
            this.setState({ selected: this.props.currentValues });
    }
    
    componentDidUpdate(prevProps) {
        if(this.props.currentValues !== prevProps.currentValues) {
            if(Array.isArray(this.props.currentValues))
                this.setState({ selected: this.props.currentValues });
        }
    }

    search = (e) => {
        if (!e.target.value) {
            this.setState({ diagCodes: [] });
            return;
        }
        qreq.post('/api/diagcode/list', { search: e.target.value }, j => {
            if (this.state.touched)
                return;
            if (j.list)
                this.setState({ diagCodes: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    change = (e) => {
        this.setState({ touched: true, search: e.target.value });
    }

    tick = () => {
        if (this.state.touched) {
            this.setState({ touched: false });
            this.search({ target: { value: this.state.search } });
        }
    }

    select = (i) => {


        let selected = [...this.state.selected];

        console.log('select', i, this.state.selected);

        if (this.isSelected(i)) {
            selected = selected.filter(j => j.id !== i.id);
        } else {
            selected.push(i);
        }

        this.setState({ selected });
        this.props.onChange?.(selected);
    }

    isSelected = (i) => {
        return this.state.selected.find(j => j.id === i.id);
        
    }

    render() {
        return <>
            <Tick interval={1000} onTick={this.tick} />
            {!this.props.disabled && <input type="text" className="form-control mb-3" placeholder="Search diagnosis code or description..." onChange={this.change} />}
            {this.state.selected.length === 0 ? <div className="text-muted"><L>No Diagnosis Codes Selected</L></div> : <table className="table">
                <thead>
                    <tr>
                        <th><L>DiagCode</L></th>
                        <th><L>Description</L></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.selected.map((i, idx) => <tr key={idx}>
                        <td>{i.code}</td>
                        <td>{i.description}</td>
                        <td className="text-end">
                            {!this.props.disabled && <button type="button" className="btn-close" onClick={() => this.select(i)}></button>}
                        </td>
                    </tr>)}
                </tbody>
            </table>}
            {!this.props.disabled && this.state.diagCodes?.map((i, idx) => <div key={idx} className="border-bottom my-2">
                <div className="row align-items-center">
                    <div className="col-3 col-md-2 col-lg-2">
                        <button type="button" className={'btn w-100 ' + (this.isSelected(i) ? 'btn-success' : 'btn-primary')} onClick={() => this.select(i)}>{i.displayCode}</button>
                    </div>
                    <div className="col-9 col-md-10 col-lg-10">
                        {i.description}
                    </div>
                </div>
            </div>)}
        </>;
    }
}